import { Route } from "@/routes/routes.types";

export const routes = {
    login: { path: "/login" },
    timeline: { path: "/timeline" },
    individuals: { path: "/individuals" },
    projects: { path: "/projects" },
    dashboard: { path: "/dashboard" },
    helloWorld: { path: "/hello-world" },
} as const satisfies Record<string, Route>;

export type Routes = typeof routes;
export type RoutesPaths = Routes[keyof Routes]["path"];
